import { render, staticRenderFns } from "./ListTapeItems.vue?vue&type=template&id=008d1c80&scoped=true&"
import script from "./ListTapeItems.vue?vue&type=script&lang=js&"
export * from "./ListTapeItems.vue?vue&type=script&lang=js&"
import style0 from "./ListTapeItems.vue?vue&type=style&index=0&id=008d1c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d1c80",
  null
  
)

export default component.exports